import { PrivacySettingToggles } from '@prisjakt/web-app-config/dist/markets/types';

const acceptCookies = (
  version: string,
  privacySettings?: PrivacySettingToggles,
  isLoggedIn?: boolean
) =>
  ({
    type: 'ACCEPT_COOKIES',
    version,
    privacySettings,
    isLoggedIn,
  } as const);

export default acceptCookies;
